import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteLectureItem as deleteLectureItemApi } from "../../../../services/dashboard/apiLecture";
import toast from "react-hot-toast";

export function useDeleteLectureItem() {
  const queryClient = useQueryClient();

  const {
    mutate: deleteLectureItem,
    isLoading: isDeleting,
    error,
  } = useMutation({
    mutationFn: deleteLectureItemApi,
    onSuccess: () => {
      toast.success("تم حذف المحتوي بنجاح");

      queryClient.invalidateQueries({
        queryKey: ["lectureItemsDashboard"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { deleteLectureItem, isDeleting, error };
}
